import {  
  loadInterpretationFileDataInProgress,
  loadInterpretationFileDataSuccess,
  loadInterpretationFileDataFailure,
  closeInterpretationFileDialog,
  interpretationFileOperationCompleted,
} from "../state/interpretationfile/actions";
import swal from 'sweetalert';
import configData from "../config.json";
import { errorSweetAlert, fileSchemaSweetAlert, oopsSweetAlert } from '../components/SweetAlertMessages';
import { oktaAuth } from '../auth/okta';
const serverBasePath=configData.SERVER_API_URL;


export const loadInterpretationFilesList = (page=0,pageSize=10,controllerId='') => async (dispatch) => {
  const token = oktaAuth.getAccessToken();
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadInterpretationFileDataInProgress());
    const response = await fetch(serverBasePath+"/homepage/getInterpretationFiles?page="+page+"&pageSize="+pageSize+"&controllerId="+controllerId,
    {
      method: "GET", 
      headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
      }
    });
    const result = await response.json();
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    dispatch(loadInterpretationFileDataSuccess(result));
  } catch (e) {
    dispatch(loadInterpretationFileDataFailure());
    errorSweetAlert(e); 
  }
};

export const addNewInterpretationFile = (data) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  dispatch(loadInterpretationFileDataInProgress());
  try {
      const response = await fetch(serverBasePath+"/homepage/addNewInterpretationFile", 
      {
        method: "POST",  
        headers: {
          Authorization: 'Bearer ' + token,       
          'type': 'formData',
        },
        body:data
      });
      dispatch(interpretationFileOperationCompleted());
      const result = await response.json();
      if(response.status === 500 && result?.errors){
          fileSchemaSweetAlert(result);
          return;
      }
      if(response.status !== 200){
          oopsSweetAlert(result);
          return;
      }
      dispatch(closeInterpretationFileDialog());
      swal({
          title: "Success",
          text: result.message,
          icon: "success",
          closeOnClickOutside:false,
          closeOnEsc: false,
          allowOutsideClick: false,
      }).then(marked => {
        if (marked) {
          dispatch(loadInterpretationFilesList(''));
        }
      });
  } catch (e) {
      dispatch(loadInterpretationFileDataFailure());
      errorSweetAlert(e);
  }
};



export const downloadInterpretationFile = (rowId,fileName) =>  {
    return async (dispatch) => {
        const token = oktaAuth.getAccessToken();
        if (!token) throw new Error('No access token');
        try {
            dispatch(loadInterpretationFileDataInProgress());
            const response = await fetch(serverBasePath+"/homepage/"+rowId+"/interpretation/download",
            {
                method: "GET",
                headers: {
                    Authorization: 'Bearer ' + token,
                }
            });
            if(response.status === 500){
                dispatch(interpretationFileOperationCompleted()); 
                const error = {'message': 'Internal Server Error'};
                oopsSweetAlert(error);
                return;
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',fileName); 
            document.body.appendChild(link);
            link.click();
            dispatch(interpretationFileOperationCompleted()); 
        } catch (e) {   
            dispatch(loadInterpretationFileDataFailure());
            errorSweetAlert(e);  
        }
    };
};


export const deleteInterpretationFile = (id) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadInterpretationFileDataInProgress());
          const response = await fetch(serverBasePath+"/homepage/delete/"+id,
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            }
          });
          dispatch(interpretationFileOperationCompleted()); 
          const result = await response.json();
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                dispatch(loadInterpretationFilesList(''));
              }
          });
      } catch (e) {   
        dispatch(loadInterpretationFileDataFailure());
        errorSweetAlert(e); 
      }
  };
};


export const setLatestInterpretationFile = (rowId,controllerId) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadInterpretationFileDataInProgress());
          const response = await fetch(serverBasePath+"/homepage/"+rowId+"/setlatest/"+controllerId,
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            }
          });
          dispatch(interpretationFileOperationCompleted()); 
          const result = await response.json();
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                dispatch(loadInterpretationFilesList(''));
              }
          });
      } catch (e) {   
          dispatch(loadInterpretationFileDataFailure());
          errorSweetAlert(e); 
      }
  };
};